import type { Verdict } from './api';

export { MIN_REMARKS_LENGTH, RATING_CONTENT_MAX_WIDTH } from '../rlhfShared/constants';

/** Shared constants for the RLHF pairwise-comparison workbench. */

/**
 * The two verdicts, in the order they're shown: A on the left and B on the right, matching the
 * panes above so the control reads as a direction rather than a list of options.
 *
 * Forced choice — no tie. A rater facing two equivalent reports still has to pick, and their
 * remarks are where that gets said.
 */
export const VERDICT_OPTIONS: { value: Verdict; label: string; hint: string }[] = [
  { value: 'a', label: 'A is better', hint: 'The left report answers the brief better' },
  { value: 'b', label: 'B is better', hint: 'The right report answers the brief better' },
];
